module.exports = __webpack_public_path__ + "static/Grafika4-e58fb4c5d1ab4905e93c43a53fe042a2.png";